import { UserPermission, UserGroup } from "../dtos";
export interface AuthState {
    // Loading state
    isLoading: boolean;
    // Global state for user and auth data
    globalState: {
      first_name: string | null;
      last_name: string | null;
      full_name: string | null;
      email: string | null;
      mobile: string | null;
      subject_id: string | null;
      creation_date: string | null;
      last_accessed_branch_id: number | null;
      user_groups: UserGroup[];
      user_permissions: UserPermission[];
      last_login: string | null;
      user_branches: string | null;
      // Token data
      access_token: string | null;
      id_token: string | null;
      refresh_token: string | null;
      expires_at: number | null;
      tenant_id: number | null;
      storefront_id: number | null;
      currency_code: string | null; // Add this
      exchange_rate: number | null; // Add this
    };
  }
  
  export const initialState: AuthState = {
    isLoading: true,
    globalState: {
      first_name: null,
      last_name: null,
      full_name: null,
      email: null,
      mobile: null,
      subject_id: null,
      creation_date: null,
      last_accessed_branch_id: null,
      user_groups: [],
      user_permissions: [],
      last_login: null,
      user_branches: null,
      // Token data
      access_token: null,
      id_token: null,
      refresh_token: null,
      expires_at: null,
      tenant_id: null,
      storefront_id: null,
      currency_code: null, // Add this
      exchange_rate: null, // Add this
    },
  };